import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { AjaxService } from "../../../service/ajax.service";
import { API } from "src/environments/environment";
import { UserService } from "src/app/services/user.service";

interface Message {
  id: number;
  senderId: number;
  senderName: string;
  senderAvatar: string;
  content: string;
  timestamp: Date;
  isRead: boolean;
}

@Component({
  selector: "app-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.scss"],
})
export class ChatComponent implements OnInit {
  @ViewChild("messagesContainer") private messagesContainer!: ElementRef;

  messageForm: FormGroup;
  messages: Message[] = [];
  currentClientId: number | null = null;
  currentClientName: string = "";
  currentClientAvatar: string = "";
  isOnline: boolean = true;
  private shouldScrollToBottom: boolean = true;
  user: any;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private ajaxService: AjaxService,
    private auth: UserService
  ) {
    this.messageForm = this.fb.group({
      message: ["", [Validators.required, Validators.minLength(1)]],
    });
  }

  ngOnInit() {
    this.user = this.auth.getUser();
    this.route.queryParams.subscribe((params) => {
      const clienteId = params["clienteId"];
      this.currentClientName = params["clienteNome"];
      if (clienteId) {
        this.loadClientData(clienteId);
        this.loadMessages(clienteId);
      }
    });
  }

  refreshMessages() {
    if (!this.loading && this.currentClientId) {
      this.loadMessages(this.currentClientId);
    }
  }

  private loadClientData(clienteId: number) {
    this.currentClientId = clienteId;
    this.currentClientAvatar = "assets/images/avatars/default-avatar.png";
  }

  private loadMessages(clienteId: number) {
    this.loading = true;
    this.shouldScrollToBottom = true;
    let url = API + "Chat/Chat?ID_USUARIO_REMETENTE="+clienteId;
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response.data && Array.isArray(response.data)) {
          this.messages = [];
          response.data.forEach(msg => {
            this.messages.push({
              id: msg.iD_CHAT,
              senderId: msg.iD_USUARIO_EMPRESA == 0 ? this.user.Id : 0,
              senderName: msg.iD_USUARIO_REMETENTE == 0 ? "Você": this.currentClientName,
              senderAvatar: "assets/images/user/user-default.png",
              content: msg.mensagem,
              timestamp: new Date(msg.datA_ENVIO),
              isRead: msg.LIDA
            });
          });
        }
        this.loading = false;
        setTimeout(() => this.scrollToBottom(), 100);
      },
      error: (error) => {
        console.error("Erro ao carregar mensagens:", error);
        this.loading = false;
      }
    });
  }

  sendMessage() {
    let user = this.auth.getUser();
    if (this.messageForm.valid && this.currentClientId) {
      const messageContent = this.messageForm.get("message")?.value;

      const messageData = {
        MENSAGEM: messageContent,
        ID_USUARIO_REMETENTE: parseInt(this.currentClientId.toString()),
        ID_USUARIO_EMPRESA: user.Id,
      };

      let url = API + "Chat/Chat";
      this.ajaxService.post(url, messageData).subscribe({
        next: (response) => {
          // Adiciona a mensagem enviada ao array local
          const newMessage: Message = {
            id: this.messages.length + 1,
            senderId: 0,
            senderName: "Você",
            senderAvatar: "assets/images/user/user-default.png",
            content: messageContent,
            timestamp: new Date(),
            isRead: true,
          };

          this.messages.push(newMessage);
          this.messageForm.reset();
          this.shouldScrollToBottom = true;
          setTimeout(() => this.scrollToBottom(), 100);
        },
        error: (error) => {
          console.error("Erro ao enviar mensagem:", error);
        },
      });
    }
  }

  private scrollToBottom(): void {
    if (!this.shouldScrollToBottom) return;
    
    try {
      const element = this.messagesContainer.nativeElement;
      element.scrollTop = element.scrollHeight;
    } catch (err) {
      console.error("Erro ao rolar para o final da conversa:", err);
    }
  }

  onScroll(event: any): void {
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop === element.clientHeight;
    this.shouldScrollToBottom = atBottom;
  }

  formatMessageTime(date: Date): string {
    return date.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  formatMessageDate(date: Date): string {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return "Hoje";
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Ontem";
    } else {
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
  }
}
